import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ElementRef, Injectable, Renderer2, DOCUMENT, inject } from '@angular/core';

import { ApWebcomponentService, WebcomponentEvent } from '@ap/webcomponent';

import { MijnOmgevingNavigation } from './mijn-omgeving.navigation';

/* eslint-disable */
@Injectable({
    providedIn: 'root'
})
export class MijnWebcomponentService extends ApWebcomponentService {
    protected readonly document = inject<Document>(DOCUMENT);
    protected readonly _httpClient = inject(HttpClient);
    protected readonly _location = inject(Location);
    private readonly navigation = inject(MijnOmgevingNavigation);

    /**
     * Adds the tag to the html.
     *
     * @param tagName The tag name.
     */
    public addWebcomponentTag(tagName: string, elementRef: ElementRef, renderer: Renderer2): void {
        super.removeWebcomponentTag(tagName, elementRef, renderer);
        const webcomponentTag: HTMLElement = document.createElement(tagName);
        renderer.appendChild(elementRef.nativeElement, webcomponentTag);
        webcomponentTag.addEventListener('interceptorError', () => this.navigation.toFout());
    }

    public addWebcomponentEventListener(tagName: string, customEvent: WebcomponentEvent): void {
        const element = document.querySelector(tagName);
        element.addEventListener(customEvent.name, (event: CustomEvent) => {
            if (event.detail) {
                this.navigation[customEvent.action](event.detail);
            } else {
                this.navigation[customEvent.action]();
            }
        });
    }
}
